import useUpdate from "@/hooks/use-update";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IServiceHoursInput } from "@/interfaces/service-hours.interface";
import serviceHoursService from "@/services/service-hours.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = {
  formData: IServiceHoursInput;
  _id: number;
} & RequestsProps;

export type Return = {
  update: (props: Props) => Promise<void>;
} & UseLoadingReturn;

const useUpdateServiceHours = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<IServiceHoursInput>({
    operation: (formData, _id) => serviceHoursService.update(formData, _id),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdateServiceHours;
